<template>
  <div class="progress-wrapper">
    <div class="progress">
      <div
        class="progress-bar"
        :class="stateClass"
        role="progressbar"
        :style="{ width: `${valuePercentage}%` }"
      />
    </div>
    <tooltip
      class="progress-threshold"
      v-if="threshold"
      :style="{ left: `${thresholdPercentage}%` }"
      data-toggle="tooltip"
      :title="thresholdTitle"
      placement="top"
    />
  </div>
</template>

<script>
  import Tooltip from './tooltip'

  export default {
    name: 'ProgressBar',
    components: {Tooltip},
    props: {
      value: {
        type: Number,
      },
      max: {
        type: Number,
        default: 100,
      },
      min: {
        type: Number,
        default: 0,
      },
      threshold: {
        type: Number,
      },
      thresholdTitle: {
        type: String,
        default: 'Порог',
      },
      state: {
        type: String,
      },
    },
    computed: {
      realMax () {
        return Math.max(this.max, this.value, this.threshold)
      },
      valuePercentage () {
        return Math.round(((this.value - this.min) / (this.realMax - this.min)) * 100)
      },
      thresholdPercentage () {
        return Math.round(((this.threshold - this.min) / (this.realMax - this.min)) * 100)
      },
      stateClass () {
        return this.state ? `bg-${this.state}` : undefined
      },
    },
  }
</script>

<style lang="scss">
  .progress-wrapper {
    position: relative;
    display: inline-block;
  }

  .progress-threshold {
    width: 2px;
    margin-left: -1px;
    position: absolute;
    top: -3px;
    bottom: -3px;
    background-color: #000;
    &:after {
      content: '';
      position: absolute;
      left: -3px;
      right: -3px;
      top: 0;
      bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/progress-bar.vue